/** Sends a crash report to the API's logs. Never throws; never sends query strings. */
export function reportClientError(app: 'web' | 'dashboard', apiBase: string, error: unknown) {
  try {
    const err = error instanceof Error ? error : new Error(String(error));
    void fetch(`${apiBase}/v1/client-errors`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({ app, message: err.message.slice(0, 500), path: window.location.pathname.slice(0, 200), stack: err.stack?.slice(0, 4000) }),
    }).catch(() => undefined);
  } catch {
    // reporting must never break the error screen
  }
}
